import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// Booking Page
import bookingPageReducer from './BookingPage';

// Receipt Page
import receiptPageReducer from './ReceiptPage';

// Payment Callback Page
import paymentCallbackPageReducer from './PaymentCallbackPage';

const rootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),

		// Booking Page
		bookingPageReducer,

		// Receipt Page
		receiptPageReducer,

		// Payment Callback Page
		paymentCallbackPageReducer
	});

export default rootReducer;
